import { render } from "./CreditReturnDetails.vue?vue&type=template&id=601b618c&scoped=true"
import script from "./CreditReturnDetails.vue?vue&type=script&lang=js"
export * from "./CreditReturnDetails.vue?vue&type=script&lang=js"

import "./CreditReturnDetails.vue?vue&type=style&index=0&id=601b618c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601b618c"]])

export default __exports__